import React from 'react'
import ContactForm from '../Components/ContactForm';

const Contact = () => {
  return (
   <>
     <ContactForm/>
   </>
  )
}

export default Contact